const mobileDeviceScreenWidth = 960;

export default mobileDeviceScreenWidth;
